// CompactStepper.jsx
import React from "react";
import { Box, Stepper, Step, StepLabel } from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

/* ---- Thin compact connector ---- */
const CompactConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 14,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: theme.palette.divider,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: theme.palette.primary.main,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: theme.palette.primary.main,
  },
}));

/* ---- Tiny dot icon ---- */
const Dot = styled("span")(({ theme, ownerState }) => ({
  display: "inline-block",
  width: ownerState.active ? 10 : 8,
  height: ownerState.active ? 10 : 8,
  borderRadius: "50%",
  transition: "all 120ms ease",
  backgroundColor:
    ownerState.completed || ownerState.active
      ? theme.palette.primary.main
      : theme.palette.action.disabled,
  boxShadow: ownerState.active
    ? `0 0 0 3px ${theme.palette.primary.main}22`
    : "none",
}));

function DotStepIcon(props) {
  const { active, completed, className } = props;
  return <Dot ownerState={{ active, completed }} className={className} />;
}

/* ---- Helper: read multiple possible keys safely ---- */
const isStepMarkedActive = (step) => {
  return Boolean(
    step?.isCurrentStepActive ??
      step?.isCirrentStepActive ?? // typo-friendly
      step?.isCurrent ??
      step?.isActive ??
      step?.active ??
      step?.current
  );
};

/* ---- Main component ---- */
export const CompactStepper = ({
  steps = [
    { label: "Pending", isCurrentStepActive: true },
    { label: "Accepted" },
    { label: "Completed" },
    { label: "Acknowledged" },
  ],
  sx,
}) => {
  // Resolve active index

  const computedIdx = steps
    .map((item) => item.isCurrentStepActive)
    .lastIndexOf(true);

  const activeStep = computedIdx >= 0 ? computedIdx : 0;

  return (
    <Box sx={{ width: "100%", minWidth: 0, ...sx }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<CompactConnector />}
        sx={{
          width: "100%",
          p: 0,
          m: 0,
          minHeight: 0,
          "& .MuiStepLabel-label": {
            fontSize: 12,
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            m: 0,
          },
          "& .MuiStepLabel-iconContainer": { p: 0, mr: 0.5 },
          "& .MuiStep-root": { p: 0, m: 0, minWidth: 0, flex: 1 },
          "& .MuiStepConnector-root": { m: 0 },
        }}
      >
        {steps.map((step, idx) => (
          <Step key={`${step.label}-${idx}`} completed={idx < activeStep}>
            <StepLabel StepIconComponent={DotStepIcon}>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
